// src/components/FindButton.jsx — ohapotato v2026.10.36
import React, { useState } from 'react';

export default function FindButton({ count, nonStapleCount, onClick, loading }) {
  const [hovered, setHovered] = useState(false);
  // Require at least 2 non-staple ingredients
  const disabled = nonStapleCount < 2 || loading;
  const needsMore = nonStapleCount === 0;
  const needsOne  = nonStapleCount === 1;

  let hint = null;
  if (needsMore) hint = 'Pick at least 2 ingredients beyond your staples';
  else if (needsOne) hint = 'Add 1 more ingredient to search';

  return (
    <div style={styles.wrap}>
      <button
        onClick={onClick}
        disabled={disabled}
        onMouseEnter={() => !disabled && setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          ...styles.btn,
          ...(disabled ? styles.disabled : styles.active),
          ...(!disabled && hovered ? styles.activeHover : {}),
        }}
      >
        {loading ? (
          <span style={styles.inner}>
            <span style={styles.spinner} />
            Searching…
          </span>
        ) : (
          <span style={styles.inner}>
            🔍 Find Recipes
            {!disabled && (
              <span style={styles.badge}>{nonStapleCount}</span>
            )}
          </span>
        )}
      </button>
      {hint && !loading && (
        <p style={styles.hint}>{hint}</p>
      )}
    </div>
  );
}

const styles = {
  wrap: { display: 'flex', flexDirection: 'column', gap: '6px' },
  btn: {
    width: '100%', padding: '13px 20px',
    border: 'none', borderRadius: 'var(--radius-md)',
    fontFamily: 'var(--font-body)',
    fontSize: '15px', fontWeight: '600',
    cursor: 'pointer', letterSpacing: '0.01em',
    transition: 'all 0.14s ease',
  },
  active: {
    background: 'var(--accent-orange)',
    color: '#fff',
    boxShadow: '0 2px 10px rgba(196,88,26,0.25)',
  },
  activeHover: {
    background: 'var(--accent-orange-light)',
    boxShadow: '0 4px 16px rgba(196,88,26,0.35)',
    transform: 'translateY(-1px)',
  },
  disabled: {
    background: 'var(--bg-pill)',
    color: 'var(--text-muted)',
    cursor: 'not-allowed',
    boxShadow: 'none',
  },
  inner: {
    display: 'flex', alignItems: 'center',
    justifyContent: 'center', gap: '8px',
  },
  badge: {
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    background: 'rgba(255,255,255,0.22)',
    borderRadius: 'var(--radius-pill)',
    minWidth: '20px', height: '20px',
    padding: '0 6px', fontSize: '11px', fontWeight: '600',
  },
  spinner: {
    display: 'inline-block', width: '13px', height: '13px',
    border: '2px solid rgba(255,255,255,0.3)',
    borderTopColor: '#fff', borderRadius: '50%',
    animation: 'spin 0.7s linear infinite',
  },
  hint: {
    textAlign: 'center', fontSize: '12px',
    color: 'var(--text-muted)', fontFamily: 'var(--font-body)',
    margin: 0, lineHeight: '1.4',
  },
};
